import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-mobile-search-modal',
  templateUrl: './mobile-search-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileSearchModalComponent implements OnInit, OnDestroy {
  constructor(private repository: HelixBookRepositoryService) {}

  @Input() container: ViewContainerRef | undefined;
  ngUnsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.repository.scrollEvent$
      .pipe(
        filter((x) => x),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        this.closeModal();
      });
  }

  closeModal(): void {
    this.container?.clear();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
